import { Injectable } from '@angular/core';
import { Permission } from '../../permission/permission';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const Permission_TYPE = Permission;

const MENUITEMS = [
  {
    label: 'Home',
    main: [
      {
        state: 'dashboard',
        short_label: 't',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-bar-chart-alt',
      }
    ]
  },
  {
    label: 'GR/GI',
    main: [
      {
        state: 'goods-issue',
        name: 'การตัดจ่ายสินค้า',
        type: 'link',
        icon: 'ti-package',
        p_type: Permission_TYPE.GoodsIssue,
      },
      {
        state: 'edit-delivery',
        name: 'แก้ไขข้อมูล Delivery',
        type: 'link',
        icon: 'ti-package',
        p_type: Permission_TYPE.ChangDelivery,
      },
      {
        state: 'cancel-goods',
        name: 'ยกเลิกการตัดจ่ายสินค้า',
        type: 'link',
        icon: 'ti-package',
        p_type: Permission_TYPE.CancelGoodsIssue,
      },
      {
        state: 'return-goods',
        name: 'รับคืนสินค้า',
        type: 'link',
        icon: 'ti-package',
        p_type: Permission_TYPE.GoodsReturn,
      },
    ]
  },
  {
    label: 'USER & AUTHORIZATION',
    main: [
      {
        state: 'list',
        short_label: 'userlh',
        main_state: 'grouppermission',
        name: 'Group-Permission',
        type: 'link',
        icon: 'ti-id-badge',
        p_type: Permission_TYPE.PERMISSION,
      },
      {
        state: 'list',
        short_label: 'userlh',
        main_state: 'user',
        name: 'User-Manage',
        type: 'link',
        icon: 'ti-id-badge',
        p_type: Permission_TYPE.USER,
      },
    ]
  },
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
}
